import apiClient from "@/services/apiClient";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const ueExpensesCommonCrudService = {
    async getAll(expenseType: string, params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/expense/${expenseType}/all`,
                paramsCopy
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching treatment-benefit list", error);
            throw error;
        }
    },

    async findById(expenseType: string, id: string): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/expense/${expenseType}/findById/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error findById " + expenseType, error);
            throw error;
        }
    },

    async create(expenseType: string, dto: any): Promise<any> {
        try {
            let url = 'create';
            if (dto.isCreateClone) {
                url = 'createClone';
            }
            const response = await apiClient.post<any>(`${BASE_URL}/api/v1/expense/${expenseType}/${url}`, dto);
            return response.data;
        } catch (error) {
            console.error("Error create " + expenseType, error);
            throw error;
        }
    },

    async save(expenseType: string, item: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/expense/${expenseType}/save`,
                item
            );
            return response.data;
        } catch (error) {
            console.error("Error save " + expenseType, error);
            throw error;
        }
    },

    async deleteById(expenseType: string, id: string): Promise<any> {
        try {
            const response = await apiClient.delete<any>(`${BASE_URL}/api/v1/expense/${expenseType}/deleteById/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteById " + expenseType, error);
            throw error;
        }
    },
    async deleteCategory(expenseType: string, id: string, catId: string): Promise<any> {
        try {
            const response = await apiClient.delete<any>(`${BASE_URL}/api/v1/expense/${expenseType}/deleteCategory/${id}/${catId}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteCategory " + expenseType, error);
            throw error;
        }
    },
    async getAllDefaultCategories(expenseType: string): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/expense/${expenseType}/getAllDefaultCategories`);
            return response.data;
        } catch (error) {
            console.error("Error getAllDefaultCategories " + expenseType, error);
            throw error;
        }
    },
    async getMaterialsContingentShares(trancheYear: number, universityId: number): Promise<any> {
        try {
            const response = await apiClient.get<any>(
                `${BASE_URL}/api/v1/expense/materials/contingentShares/${trancheYear}/${universityId}`
            );
            return response.data;
        } catch (error) {
            console.error("Error fetching materials contingent shares", error);
            return {};
        }
    },
    async generateAndGetXls(expenseType: string, uuid: string, params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);

            return await apiClient.post<any>(
                `${BASE_URL}/api/v1/expense/${expenseType}/generate/xls/${uuid}`,
                paramsCopy,
                {
                    responseType: "blob"
                }
            )
        } catch (error) {
            console.error("Error fetching directory list:", error);
            throw error;
        }
    },

}

export default ueExpensesCommonCrudService;
